export default function _withoutIndex(iteratee) {
    return function (value, index, callback) {
        return iteratee(value, callback);
    };
}



// WEBPACK FOOTER //
// ../../../../node_modules/async-es/internal/withoutIndex.js